// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WithCSSTooltip_wrapper_3gAOO","tooltip":"WithCSSTooltip_tooltip_3lCKM","tooltipContent":"WithCSSTooltip_tooltipContent_3INk0"};